import React, { useEffect, useState } from 'react';
import '../../../styles/admin/AdminTable.css';

const API_URL = process.env.REACT_APP_API_URL;

function InfluencerSNSUpdateList({ onSelect, selectedId, interactive = true, refreshToken }) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  const fetchList = async () => {
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API_URL}/api/influencer/sns-refresh/pending`, { credentials: 'include' });
      if (res.status === 401) { setError('관리자 세션이 만료되었습니다.'); setItems([]); return; }
      const data = await res.json();
      if (!res.ok || !data.ok) throw new Error(data.message || '불러오기 실패');
      setItems(data.items || []);
    } catch (e) {
      setError(e.message || '불러오기 실패');
    }
    setLoading(false);
  };

  useEffect(() => { fetchList(); }, [refreshToken]);

  const fmt = (ts) => ts ? new Date(ts).toLocaleString() : '';

  return (
    <div className="admin-list">
      <div className="admin-list__header">팔로워 수 갱신 요청</div>
      
      <div className="admin-list__body admin-list__body--fixed-height">
        {error && <div className="admin-list__error">{error}</div>}
        {loading && <div className="admin-list__loading">불러오는 중...</div>}
        {!loading && items.length === 0 && !error && <div className="admin-list__empty">갱신 요청이 없습니다.</div>}
        
        {!loading && items.length > 0 && (
          <div>
            {items.map((u) => (
              <div
                key={u.ownerId}
                onClick={interactive && onSelect ? () => onSelect(u) : undefined}
                className={`admin-list__item ${
                  selectedId && (selectedId === (u.ownerId)) ? 'admin-list__item--selected' : ''
                }`}
                style={{ cursor: interactive ? 'pointer' : 'default' }}
              >
                <div className="admin-list__item-row">
                  <div className="admin-list__item-main">
                    {u.userId} ({u.userName})
                  </div>
                  <div className="admin-list__item-sub">{fmt(u.requestedAt)}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default InfluencerSNSUpdateList;
